import React from 'react';
import { Button } from '@asigna/kit';
import cx from 'classnames';
import CodeIcon from 'images/code.svg';

import { Application } from '../../appList';

import bg1Image from './utils/images/bg1.svg';
import bg2Image from './utils/images/bg2.svg';
import bg3Image from './utils/images/bg3.svg';

import s from './index.module.scss';

export const EmbeddedBadge = () => (
  <div className="text-[#B1A9FF] bg-[#7955F51A] px-[8px] py-[4px] text-m12 flex gap-8 w-[103px] rounded-[4px]">
    <img src={CodeIcon} alt="" />
    Embedded
  </div>
);

export type AppCardProps = {
  app: Application;
  isDashboard?: boolean;
  onClick: (app: Application) => void;
  index?: number;
};

export const AppCard: React.FC<AppCardProps> = React.memo(
  ({ app, index = -1, isDashboard, onClick }) => {
    const { url, logo, caption, description, category } = app;

    return (
      <div
        className="bg-black-2 hover:bg-primary-5 p-16 sm:p-20 rounded-[12px] w-full flex items-start flex-row gap-12 border-[.5px] border-black-4 hover:border-primary cursor-pointer relative"
        onClick={(e) => {
          e.stopPropagation();
          onClick(app);
        }}
      >
        {isDashboard && index > -1 && (
          <div
            className="absolute inset-0 bg-[left_top_1rem] bg-cover blur-2xl z-0"
            style={{
              backgroundImage: `url(${
                index % 3 === 0 ? bg1Image : index % 3 === 1 ? bg2Image : bg3Image
              })`,
            }}
          />
        )}
        <div className="flex justify-between items-center">
          <div className="w-56 h-56 rounded-[32px] border border-white-5 flex items-center justify-center bg-white-10">
            <img src={logo} className="rounded-[32px] w-32 h-32" alt="" />
          </div>
        </div>
        <div className="flex flex-col flex-1 gap-8 self-stretch">
          <div className="flex items-center gap-8">
            <p className="text-m16 text-white text-left">{caption}</p>
            {!app.isExternal && <EmbeddedBadge />}
          </div>
          <p
            className={cx(
              'text-r14 text-regular text-left',
              isDashboard ? s.twolines : s.treelines
            )}
          >
            {description || ''}
          </p>

          {isDashboard ? (
            <Button
              message="Launch app"
              colorType="secondary"
              className="mt-16 hover:bg-white-10 transition-all z-10"
              size="sm"
            />
          ) : (
            <div className="flex gap-4">
              {category.map((category: string) => (
                <p
                  key={`${url}--${category}`}
                  className="px-12 py-4 rounded-[16px] bg-black-3 text-r12"
                >
                  {category}
                </p>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }
);
